import { AssetListItem } from '~src/spacesPlatform/models/AssetListItem';
import { ExploreContentApi_ContentType, isExploreContentApiContentType } from '~src/spacesPlatform/models/IContent';

const AllowedFavoriteContentTypes = {
  collection: 'collection',
  datasource: 'datasource',
  flow: 'flow',
  project: 'project',
  virtualConnection: 'virtualConnection',
  virtualConnectionTable: 'virtualConnectionTable',
  view: 'view',
  workbook: 'workbook',
};

export type FavoriteItemType = keyof typeof AllowedFavoriteContentTypes;

export function filterFavoritableContentTypes(
  favoritableContentTypes: ReadonlyArray<string>
): ExploreContentApi_ContentType[] {
  return favoritableContentTypes.filter(isExploreContentApiContentType);
}

export function contentTypeCanBeFavorite(
  contentType: string,
  favoritableContentTypes?: ReadonlyArray<string>
): contentType is FavoriteItemType {
  if (favoritableContentTypes) {
    return filterFavoritableContentTypes(favoritableContentTypes).some(type => type === contentType);
  }
  return AllowedFavoriteContentTypes.hasOwnProperty(contentType);
}

export interface IFavorite extends AssetListItem {
  objectLuid?: string;
  objectType: FavoriteItemType;
  objectIdForFavoriting: string; // will match objectId except for datasources. See IDataSourceInfo
}

export const FavoriteKeys = {
  position: 'position'
};
